import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Table  } from 'antd';
import Card from "components/card";
import { getEmployeesOnInvoiceOTAbsences } from "../../../../redux/invoice/invoiceState";
import EmployeeProfile from "components/card/EmployeeProfile";
import avatar from "assets/img/avatars/user.png";
import { NumberFormatter } from "../../../../utils/index";

const EmployeeOvertimeAbsencesTable = ({invoiceRecord, recordList, getEmployeeOTAbsences}) => {

  	const columns = [
		{
	        title: `Employee`,
	        dataIndex: 'inv_number',
	        key: 'inv_number',
	        width: '15%', 	        
	        render:(_, record) => (
				<EmployeeProfile
					avatar={avatar}
					record={record}
				/>
			),
	    },
		{
	        title: <div className="text-right">Base Salary</div>,
	        dataIndex: 'basic_pay',
	        key: 'basic_pay',
	        width: '8%', 	        
	        render:(basic_pay) => <div className="text-right">{NumberFormatter(basic_pay)}</div> 
	    },
	    {
	        title: <div className="text-right">De Minimis</div>,
	        dataIndex: 'de_minimis',
	        key: 'de_minimis',
	        width: '8%',
			render:(de_minimis) => <div className="text-right">{NumberFormatter(de_minimis)}</div> 
	    },
		{
	        title: <div className="text-right">Total</div>,
	        dataIndex: 'monthly_salary',
	        key: 'monthly_salary',
	        width: '8%',
			render:(monthly_salary) => <div className="text-right">{NumberFormatter(monthly_salary)}</div> 
	    },
		{
	        title: <div className="text-right">/Day</div>,
	        dataIndex: 'daily_rate',
	        key: 'daily_rate',
	        width: '8%',
			render:(daily_rate) => <div className="text-right">{NumberFormatter(daily_rate)}</div> 
	    },
		{
	        title: <div className="text-right">/hr</div>,
	        dataIndex: 'hour_rate',
	        key: 'hour_rate',
	        width: '8%',
			render:(hour_rate) => <div className="text-right">{NumberFormatter(hour_rate)}</div> 
	    },
		{
	        title: <div className="text-center">Total OT</div>,
	        dataIndex: 'total_overtime',
	        key: 'total_overtime',
	        width: '8%',
			render:(total_overtime) => <div className="text-right">{NumberFormatter(total_overtime)}</div> 
	    },
		{
	        title: <div className="text-center">Total Absent & Late</div>,
	        dataIndex: 'total_absent_late',
	        key: 'total_absent_late',
	        width: '8%',
			render:(total_absent_late) => <div className="text-right">{NumberFormatter(total_absent_late)}</div> 
	    },
    ];
	
	useEffect(() => {
		if(invoiceRecord?.inv_id){
			getEmployeeOTAbsences({recordId: invoiceRecord?.inv_id});
		}
    }, [getEmployeeOTAbsences, invoiceRecord]);

  	return ( <>
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns}
					pagination={false}
	        	/>
	      	</div>
	    </Card>
	</>
  );
};

const mapStateToProps = (state) => ({
	invoiceRecord: state.invoice.invoiceDetails?.data,
	recordList: state.invoice.employeesOnInvoiceOTAbsences?.items,
  	requesting: state.invoice.employeesOnInvoiceOTAbsences?.requesting,
  	error: state.invoice.employeesOnInvoiceOTAbsences?.error,
});

const mapDispatchToProps = (dispatch) => ({
  getEmployeeOTAbsences: (id) => dispatch(getEmployeesOnInvoiceOTAbsences(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeOvertimeAbsencesTable);
